import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getSearchProviders } from "../../redux/slice/provider-search/searchProvidersSlice";

import {
  getCitiesByState,
  getStatesByCountry,
} from "../../redux/slice/form-field/formFieldSlice";
import { getLocalStorageItem, setLocalStorageItem } from "../../service/utils";
import RefineNetworkSearchForm from "../forms/RefineNetworkSearchForm";
import RefineProviderNetworkSearchForm from "../forms/RefineProviderNetworkSearchForm";
import ProviderSearchTable from "../tables/ProviderSearchTable";
import NetworkSearchInfo from "./NetworkSearchInfo";

const NetworkSearch = ({ isProviderNetworkSearch }) => {
  const dispatch = useDispatch();
  const [providerForm, setProviderForm] = useState(isProviderNetworkSearch);

  const [providerData, setProviderData] = useState({
    countrySearch: "",
    stateSearch: "",
    citySearch: "",
    zipSearch: "",
    organizationSearch: "",
    pageNumber: 1,
    delta: 10,
    sortDirection: 2,
    sortingField: "",
    addressSearch: null,
    specialitySearch: "",
    isDownloadPdf: false,
    isSpecialitySearch: false,
  });

  const { providers, searchParams } = useSelector(
    (state) => state.searchProviders
  );

  const totalCount = useSelector((state) => state.searchProviders.totalCount);
  const totalPages = Math.ceil(totalCount / providerData.delta);

  useEffect(() => {
    const searchItems = getLocalStorageItem("searchValues");
    if (searchItems) {
      searchItems.countrySearch &&
        dispatch(getStatesByCountry(searchItems.countrySearch));
      searchItems.stateSearch &&
        dispatch(
          getCitiesByState({
            country: searchItems.countrySearch,
            state: searchItems.stateSearch,
          })
        );
    }

    const networkSearchPayload = {
      ...providerData,
      countrySearch:
        searchItems && searchItems.countrySearch !== undefined
          ? searchItems.countrySearch
          : providerData.countrySearch,
      stateSearch:
        searchItems && searchItems.stateSearch !== undefined
          ? searchItems.stateSearch
          : providerData.stateSearch,
      citySearch:
        searchItems && searchItems.citySearch !== undefined
          ? searchItems.citySearch
          : providerData.citySearch,
      zipSearch:
        searchItems && searchItems.zipSearch !== undefined
          ? searchItems.zipSearch
          : providerData.zipSearch,
      organizationSearch:
        searchItems && searchItems.organizationSearch !== undefined
          ? searchItems.organizationSearch
          : providerData.organizationSearch,
      pageNumber:
        searchItems && searchItems.pageNumber !== undefined
          ? searchItems.pageNumber
          : providerData.pageNumber,
      delta:
        searchItems && searchItems.delta !== undefined
          ? searchItems.delta
          : providerData.delta,
      sortDirection:
        searchItems && searchItems.sortDirection !== undefined
          ? searchItems.sortDirection
          : providerData.sortDirection,
      sortingField:
        searchItems && searchItems.sortingField !== undefined
          ? searchItems.sortingField
          : providerData.sortingField,
      addressSearch:
        searchItems && searchItems.addressSearch !== undefined
          ? searchItems.addressSearch
          : providerData.addressSearch,
      isSpecialitySearch: false,
    };

    const providerNetworkSearchPayload = {
      ...providerData,
      specialitySearch:
        searchItems && searchItems.specialitySearch !== undefined
          ? searchItems.specialitySearch
          : "",
      isSpecialitySearch: true,
    };

    const isSpeciality =
      searchItems && searchItems.isSpecialitySearch !== undefined
        ? searchItems.isSpecialitySearch
        : false;

    setProviderForm(isSpeciality);

    const searchPayload =
      isSpeciality || isProviderNetworkSearch
        ? providerNetworkSearchPayload
        : networkSearchPayload;
    setProviderData(searchPayload);
    dispatch(getSearchProviders(searchPayload));
  }, []);

  useEffect(() => {
    setProviderData({
      ...providerData,
      countrySearch: searchParams.countrySearch
        ? searchParams.countrySearch
        : "",
      stateSearch: searchParams.stateSearch ? searchParams.stateSearch : "",
      citySearch: searchParams.citySearch ? searchParams.citySearch : "",
      zipSearch: searchParams.zipSearch ? searchParams.zipSearch : "",
      organizationSearch: searchParams.organizationSearch
        ? searchParams.organizationSearch
        : "",
      specialitySearch: searchParams.specialitySearch
        ? searchParams.specialitySearch
        : "",
      isSpecialitySearch: searchParams.isSpecialitySearch
        ? searchParams.isSpecialitySearch
        : false,
    });
  }, [searchParams]);

  const handlePageChange = (page) => {
    const searchPayload = {
      ...providerData,
      pageNumber: page,
    };
    setProviderData(searchPayload);
    setLocalStorageItem("searchValues", searchPayload);

    dispatch(getSearchProviders(searchPayload));
  };

  const handleSort = (column) => {
    const newSortDirection =
      providerData.sortingField === column && providerData.sortDirection === 2
        ? 1
        : 2;

    setProviderData({
      ...providerData,
      sortingField: column,
      sortDirection: newSortDirection,
    });

    const searchPayload = {
      ...providerData,
      sortingField: column,
      sortDirection: newSortDirection,
    };

    dispatch(getSearchProviders(searchPayload));
  };

  return (
    <>
      <NetworkSearchInfo
        providerData={providerData}
        isProviderNetworkSearch={providerForm}
      />

      <div className="row provider-container provider-search-container">
        {providerForm ? (
          <RefineProviderNetworkSearchForm
            providerData={providerData}
            setProviderData={setProviderData}
          />
        ) : (
          <RefineNetworkSearchForm
            providerData={providerData}
            setProviderData={setProviderData}
          />
        )}
        <ProviderSearchTable
          data={providers}
          onPageChange={handlePageChange}
          isProviderSearch={providerForm}
          handleSort={handleSort}
          totalPages={totalPages}
          delta={providerData.delta}
          pageNumber={providerData.pageNumber}
        />
      </div>
    </>
  );
};

export default NetworkSearch;
